import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import WhitelogoImg from "../images/logo-white.svg"

const Container = ({ className, children }) => {
  return (
    <div className={`max-w-6xl mx-auto px-5 lg:px-6 ${className && className}`}>
      {children}
    </div>
  )
}

const LinkButton = ({ text, url, type, size, className, target }) => {
  const primaryStyle = "text-white bg-linkBlue"
  const secondaryStyle = "text-linkBlue bg-white"
  const sizeS = "text-xs pt-3 pb-3 pl-3 pr-3"
  const sizeM =
    "text-sm lg:text-base lg:w-52 min-w-max px-3 py-3 lg:py-4 lg:px-4"

  return (
    <a href={url} target={target}>
      <div
        className={`${type === "secondary" ? secondaryStyle : primaryStyle} ${
          size === "s" ? sizeS : sizeM
        } font-bold rounded text-center hover:opacity-90 inline-block ${className}`}
      >
        {text}
      </div>
    </a>
  )
}

const CdpFooter = () => {
  return (
    <footer className="cdp-footer">
      <section className="bg-gradient-to-r from-gradationAccent-from to-gradationAccent-to pt-10 pb-10 lg:pt-20 lg:pb-20">
        <Container>
          <h2 className="text-white text-lg lg:text-4xl font-bold text-center mb-4 lg:mb-8">
          顧客データを一元管理するCDP「INTEGRAL-CORE」
          </h2>
          <div className="flex justify-center flex-gap-3">
            <LinkButton
              text="お問合せ"
              url="https://www.ever-rise.co.jp/integral-core/contact/"
              type="primary"
              target="_blank"
            />
            <LinkButton
              text="製品資料ダウンロード"
              url="https://www.ever-rise.co.jp/integral-core/resource/integral-core/"
              type="secondary"
              target="_blank"
            />
          </div>
        </Container>
      </section>
    </footer>
  )
}

export default CdpFooter
